export const OTP_ERROR = 'ONE_TIME_PASSWORD_REQUIRED'
